module.exports = __webpack_public_path__ + "img/1368593845.efd4565e.jpg";